import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const SITE_URL = 'https://pindou.scsclub.xyz'
const DEFAULT_DESCRIPTION =
  '豆田造物是免费的在线拼豆图纸生成器。上传图片即可转换像素拼豆图，自动匹配常用品牌色号、统计豆子用量，并导出高清 PNG/PDF 图纸。'

const publicPages = [
  {
    match: (path) => path === '/',
    title: '免费拼豆图纸生成器｜图片转像素画、拼豆色号匹配 - 豆田造物',
    description: DEFAULT_DESCRIPTION,
  },
  {
    match: (path) => path === '/gallery',
    title: '拼豆图集｜发现和分享拼豆作品 - 豆田造物',
    description: '浏览豆田造物拼豆图集，发现热门拼豆作品、配色灵感和可复用的拼豆图纸。',
  },
  {
    match: (path) => path.startsWith('/gallery/'),
    title: '拼豆作品详情｜图纸与色号 - 豆田造物',
    description: '查看拼豆作品图纸、成品效果、品牌色号和豆子用量。',
  },
  {
    match: (path) => path.startsWith('/user/'),
    title: '拼豆创作者主页 - 豆田造物',
    description: '查看豆田造物拼豆创作者公开分享的作品。',
  },
  {
    match: (path) => path === '/pricing',
    title: '会员与 AI 生图额度 - 豆田造物',
    description: '查看豆田造物会员权益、高清拼豆图纸导出和 AI 生图额度。',
  },
]

const privatePaths = ['/login', '/register', '/profile', '/admin']

function setMeta(selector, attribute, value) {
  let node = document.head.querySelector(selector)
  if (!node) {
    node = document.createElement('meta')
    const [name, key] = attribute
    node.setAttribute(name, key)
    document.head.appendChild(node)
  }
  node.setAttribute('content', value)
}

export default function SiteMeta() {
  const { pathname } = useLocation()

  useEffect(() => {
    const page = publicPages.find((item) => item.match(pathname))
    const isPrivate = privatePaths.some((path) => pathname === path || pathname.startsWith(path + '/'))
    const title = page?.title || '豆田造物 - 拼豆图纸生成器'
    const description = page?.description || DEFAULT_DESCRIPTION
    const canonicalUrl = SITE_URL + (pathname === '/' ? '/' : pathname.replace(/\/$/, ''))

    document.title = title

    let canonical = document.head.querySelector('link[rel="canonical"]')
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.rel = 'canonical'
      document.head.appendChild(canonical)
    }
    canonical.href = canonicalUrl

    setMeta('meta[name="description"]', ['name', 'description'], description)
    setMeta('meta[name="robots"]', ['name', 'robots'], isPrivate ? 'noindex, nofollow' : 'index, follow, max-image-preview:large')
    setMeta('meta[property="og:title"]', ['property', 'og:title'], title)
    setMeta('meta[property="og:description"]', ['property', 'og:description'], description)
    setMeta('meta[property="og:url"]', ['property', 'og:url'], canonicalUrl)
    setMeta('meta[name="twitter:title"]', ['name', 'twitter:title'], title)
    setMeta('meta[name="twitter:description"]', ['name', 'twitter:description'], description)
  }, [pathname])

  return null
}
